"use client";

import { Config } from "@shared/lib/config/types";
import { LayoutSettings } from "@shared/types";
import { createContext, useContext } from "react";

type ClientAppProviderType = {
  layoutSettings: LayoutSettings;
  config: Config;
};

export const ClientAppProviderContext = createContext<ClientAppProviderType | null>(null);

export function ClientAppProvider({ children, layoutSettings, config }: { children: React.ReactNode; layoutSettings: any; config: any }) {
  return (
    <ClientAppProviderContext.Provider
      value={{
        layoutSettings,
        config,
      }}
    >
      {children}
    </ClientAppProviderContext.Provider>
  );
}

export function useClientConfig() {
  return useContext(ClientAppProviderContext);
}
